export enum ApplicationsStatus {
  'APPLIED' = 'Не рассмотрена',
  'DECLINED' = 'Отклонена',
  'REVOKED' = 'Отозвана',
  'SELECTED_AS_BACKUP' = 'Запасной участник',
  'SELECTED_AS_PRIMARY' = 'Основной участник',
}
